import { render, staticRenderFns } from "./SharerFeeSchedule.vue?vue&type=template&id=9d6f2f4a&scoped=true"
import script from "./SharerFeeSchedule.vue?vue&type=script&lang=js"
export * from "./SharerFeeSchedule.vue?vue&type=script&lang=js"
import style0 from "./SharerFeeSchedule.vue?vue&type=style&index=0&id=9d6f2f4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d6f2f4a",
  null
  
)

export default component.exports